export default __webpack_public_path__ + "static/NFL-Picker-Wheel-46dac98f608bc423599869015a4bb630.png";